const e = [
  "BindFingerprint",
  "BindWalletAddress",
  "GetAccountDetail",
  "GetMyHostedWallet",
  "Logout",
  "SendSetUpEmailAndPasswordOTP",
  "SendOtpCode"
];
export {
  e as SHARE_OPERATIONS_WITH_AUTH
};
//# sourceMappingURL=graphql.js.map
